import keyBy from 'lodash/keyBy';

export const tasksHashByName = (state, { tasks }) => keyBy(tasks, 'name');
